import React from "react";
import content from "../content/whoAreWe.json"; // Adjust the path as necessary
import ContentSection from "./ContentSection";

const whoAreWe = ({ language }) => {
  return <ContentSection content={content} language={language} />;
};

export default whoAreWe;
